import OdometerCounter from "../../../components/OdometerCounter";
import { motion } from "framer-motion";
import "./Counter.scss";
import Btn from "../../../components/btn/Btn";

const Counter = ({ data }) => {
  const dataList = [
    {
      id: 0,
      num: data?.count1?.match(/^\d+/),
      unit: data?.count1?.match(/[^\d]+$/),
      title: data?.count1_title,
      text: data?.count1_heading,
    },
    {
      id: 1,
      num: data?.count2?.match(/^\d+/),
      unit: data?.count2?.match(/[^\d]+$/),
      title: data?.count2_title,
      text: data?.count2_heading,
    },
    {
      id: 2,
      num: data?.count3?.match(/^\d+/),
      unit: data?.count3?.match(/[^\d]+$/),
      title: data?.count3_title,
      text: data?.count3_heading,
    },
    {
      id: 3,
      num: data?.count4?.match(/^\d+/),
      unit: data?.count4?.match(/[^\d]+$/),
      title: data?.count4_title,
      text: data?.count4_heading,
    },
    {
      id: 4,
      num: data?.count5?.match(/^\d+/),
      unit: data?.count5?.match(/[^\d]+$/),
      title: data?.count5_title,
      text: data?.count5_heading,
    },
  ];
  return (
    <section className="counter_sec p_b">
      <div className="content_wrap">
        <motion.h2
          initial={{ translateY: 32, opacity: 0 }}
          whileInView={{ translateY: 0, opacity: 1 }}
          transition={{ duration: 0.6, ease: "easeInOut" }}
          viewport={{ once: true }}
          className="title"
        >
          {data?.charity_title}
        </motion.h2>
        <motion.p
          initial={{ translateY: 32, opacity: 0 }}
          whileInView={{ translateY: 0, opacity: 1 }}
          transition={{ duration: 0.6, ease: "easeInOut", delay: 0.15 }}
          viewport={{ once: true }}
        >
          {data?.charity_description}
        </motion.p>
        <div className="counter_tri">
          {dataList?.map((data, k) => {
            return (
              <motion.div
                initial={{ translateY: 32, opacity: 0 }}
                whileInView={{ translateY: 0, opacity: 1 }}
                transition={{
                  duration: 0.6,
                  ease: "easeInOut",
                  delay: 0.15 * k,
                }}
                viewport={{ once: true }}
                className="count_wrap"
                key={data?.id}
              >
                <h2>
                  <OdometerCounter count={data?.num} />
                   <span>{" "}{data?.unit}</span>
                </h2>

                <p className="sub_title">{data?.title}</p>
                <p>{data?.text}</p>
              </motion.div>
            );
          })}
        </div>
        <div className="btn_line">
          <a href={data?.button_link} target="_blank">
            <Btn title={data?.button_name} delay={0.15} />
          </a>
        </div>
      </div>
    </section>
  );
};
export default Counter;
